<template>
  <div class="send-kitehouse">
    <div class="title receive-title">
      <p>Storage warehouse</p>
      <span v-if="canEditWaveHouse" class="btn change" @click="changeHouse">Change</span>
    </div>
    <div class="receive-home">
      <div class="img-box">
        <img src="../../../assets/imgs/send-receive.png" />
      </div>
      <div class="receiver">
        <p class="name">{{ warehouseName }}</p>
        <p class="tips">Your items are stored in this warehouse</p>
      </div>
    </div>
    <div v-if="sendInfo && curRoute !== 'sendpackge'" class="send-information">
      <div class="title fedex-title">
        <p>Send shipping</p>
        <span v-if="canEditWaveHouse" class="btn change" @click="editOrder">Edit</span>
      </div>
      <div class="fedex">
        <Fedex v-if="curRoute !== 'receive-pay'" :send-info="sendInfo">
          <p class="insurance">Shipping Insurance</p>
          <i-table border size="small" :columns="insuranceColumns" :data="sendInfo.insurances" />

          <template v-if="sendInfo.insuranceStorage">
            <i-divider style="margin-top: 45px; margin-bottom: 0" />
            <p class="insurance">Storage Insurance</p>
            <span class="value">
              {{ valueToStr[sendInfo.insuranceStorage] }}
            </span>
          </template>
        </Fedex>
        <FedexReturn v-else :back-id="backId" />
      </div>
    </div>
    <div v-if="sendInfo && sendInfo.cardNumber" style="margin-top: 36px">
      <p class="title">Payment method</p>
      <CreditCardBox :card-number="sendInfo.cardNumber" :card-brand="sendInfo.cardBrand" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Fedex from '../../../components/fedex/Fedex';
import CreditCardBox from '@/components/stripe/CreditCardBox.vue';
import { storageInsuranceValueToStr } from '@/utils/StorageInsurance';
import FedexReturn from '@/components/fedex/FedexReturn.vue';

export default {
  components: {
    FedexReturn,
    CreditCardBox,
    Fedex,
  },
  props: ['curRoute', 'backId'],
  data() {
    return {
      warehouseName: '',
      insuranceColumns: [
        { type: 'index', width: 80, align: 'center' },
        { title: 'Insurance', key: 'desc', align: 'center' },
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    changeHouse() {
      this.$store.commit('send/updateChange', true);
      this.$store.commit('home/updateChangeValue', true);
      this.$router.push({
        name: 'home',
        query: {
          change: 1,
        },
      });
    },
    init() {
      let { query } = this.$route;
      if (this.sendInfo) {
        this.warehouseName = this.sendInfo.houseCity + ', ' + this.sendInfo.houseState;
      } else {
        this.warehouseName = query.name;
      }
    },
    editOrder() {
      this.$emit('change-route', 'sendpackge');
    },
  },
  computed: {
    valueToStr() {
      return storageInsuranceValueToStr;
    },
    ...mapState('send', ['sendInfo']),
    canEditWaveHouse() {
      if (this.sendInfo && this.sendInfo.orderNum) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../../assets/css/main.less';
@import '../../../assets/fonts/font.less';
.send-kitehouse {
  .title {
    .font-regular;
    font-size: 14px;
    font-weight: 400;
    color: #262626;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-right: 6px;
    .change {
      color: @app-blue-color;
    }
  }
  .receive-home {
    width: 498px;
    height: 100px;
    border-radius: 4px;
    border: 1px solid #eeeff0;
    margin-top: 20px;
    padding: 0 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .img-box {
      width: 40px;
      img {
        width: 100%;
      }
    }
    .receiver {
      padding-left: 46px;
      .name {
        .font-regular;
        font-size: 18px;
        font-weight: 400;
        color: @app-black-color;
      }
      .tips {
        .font-light;
        font-size: 12px;
        font-weight: 300;
        color: @app-body-color;
      }
    }
  }
  .fedex-title {
    padding-top: 36px;
    align-items: center;
    .edit {
      color: @app-color;
      padding-left: 10px;
      cursor: pointer;
    }
  }
  .fedex {
    width: 498px;
    margin-top: 20px;
    border-radius: 4px;
    border: 1px solid #eeeff0;
    padding: 30px;
    .insurance {
      .font-light;
      padding: 20px 0 12px;
      font-size: 14px;
      font-weight: 300;
      color: @app-black-color;
    }
  }
  .credit-box {
    width: 498px;
    padding: 30px;
    margin-top: 20px;
    border-radius: 4px;
    border: 1px solid #eeeff0;
    display: flex;
    flex-direction: row;
    img {
      width: 40px;
      height: 40px;
    }
    .credit-card {
      padding-left: 46px;
      .number {
        .font-regular;
        height: 22px;
        font-size: 18px;
        font-weight: 400;
        color: #262626;
        line-height: 22px;
      }
      .desc {
        .font-light;
        height: 15px;
        font-size: 12px;
        font-weight: 300;
        color: #afb5c6;
        line-height: 15px;
        padding-top: 10px;
      }
    }
  }
}
.value {
  .font-regular;
  padding-top: 10px;
  color: @app-black-color;
  font-size: 16px;
  font-weight: 400;
}
</style>
